import { render, staticRenderFns } from "./ParentProfile.vue?vue&type=template&id=2e044628&scoped=true"
import script from "./ParentProfile.vue?vue&type=script&lang=js"
export * from "./ParentProfile.vue?vue&type=script&lang=js"
import style0 from "./ParentProfile.vue?vue&type=style&index=0&id=2e044628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e044628",
  null
  
)

export default component.exports